import useGetRequest, { EMPTY_RESPONSE } from "./useGetRequest";

const useNextPlans = ({ locale, permissions }) => {
  const hasPermissions = Array.isArray(permissions) && permissions.length > 0;

  const result = useGetRequest({
    urlPath: hasPermissions ? "app.plans.forPermission" : null,
    variables: {
      permission: hasPermissions ? permissions[0] : undefined
    },
    locale,
    skipAccessCheck: true
  });

  if (!hasPermissions) {
    return EMPTY_RESPONSE;
  }

  return result;
};

export default useNextPlans;
